import { ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ThemeTonalRange } from '@philips-internal/oswald-ui-constants';
import { createPromptContent } from './dialog-service-utils.js';
import './dialog-service.css';
function createDialgoService() {
    const baseConfig = {
        className: 'c-oswald-dialog',
        id: 'oswald-dialog',
        theme: ThemeTonalRange.VERY_DARK,
    };
    const alert = (options) => {
        ModalService.openDialog({
            ...baseConfig,
            dialogDescription: options.description,
            title: options.title,
        });
    };
    const confirm = (options) => {
        const executor = (resolve, reject) => {
            const onCancel = () => {
                reject();
            };
            const onConfirm = () => {
                resolve();
            };
            const buttons = [
                { action: onConfirm, title: 'Confirm', type: ModalButtonType.SUCCESS },
                { action: onCancel, title: 'Cancel', type: ModalButtonType.CANCEL },
            ];
            ModalService.openDialog({
                ...baseConfig,
                children: options.children,
                dialogDescription: options.description,
                dockButtons: buttons,
                onClose: onCancel,
                title: options.title,
            });
        };
        return new Promise(executor);
    };
    const prompt = (options) => {
        const executor = (resolve, reject) => {
            let formData = options.data;
            const onCancel = () => {
                reject();
            };
            const onConfirm = () => {
                resolve(formData);
            };
            const onFormChange = (event) => {
                formData = event.value;
            };
            const buttons = [
                { action: onConfirm, title: 'Confirm', type: ModalButtonType.SUCCESS },
                { action: onCancel, title: 'Cancel', type: ModalButtonType.CANCEL },
            ];
            const content = createPromptContent({
                data: options.data,
                description: options.description,
                fields: options.fields,
                onFormChange: onFormChange,
            });
            ModalService.openDialog({
                ...baseConfig,
                children: content,
                dockButtons: buttons,
                title: options.title,
            });
        };
        return new Promise(executor);
    };
    return {
        alert,
        confirm,
        prompt,
    };
}
const DialogService = createDialgoService();
export { DialogService, };
//# sourceMappingURL=dialog-service.js.map